
import Button from '../base/Button';

export default function ContactSection() {
  return (
    <section id="contato" className="py-20 bg-gradient-to-br from-purple-900 to-orange-600">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Pronto para se <span className="text-orange-300">Conectar</span>?
          </h2>
          <p className="text-xl mb-12 text-gray-200">
            Entre em contato conosco e descubra como a Legacy Telecom pode 
            transformar sua experiência com internet.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Telefone</h3>
              <p className="text-gray-200">(65) 4042-0692</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Email</h3>
              <p className="text-gray-200">suporte@legacytelecom.net.br</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-whatsapp-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">WhatsApp</h3>
              <p className="text-gray-200">Atendimento rápido</p>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              className="bg-white text-purple-900 hover:bg-gray-100 text-lg px-10 py-4"
              href="http://wa.me/556540420692"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Falar no WhatsApp
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              className="border-white text-white hover:bg-white hover:text-purple-900 text-lg px-10 py-4"
              href="tel:+556540420692"
            >
              <i className="ri-phone-line mr-2"></i>
              Ligar Agora
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
